import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_INSTALLATION_LOGS } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  REINIT_STATE,
  WS_RECEIVED_OPERATION,
  GET_INSTALLATION_LOGS_LIST,
  GET_INSTALLATION_LOGS_LIST_SUCCESS,
  GET_INSTALLATION_LOGS_LIST_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/installationLog';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationLog;
const installationLog = (state = initialSettings, action) => {
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
        };
      }
      return state;
    // WEB SOCKET
    case WS_RECEIVED_OPERATION:
      if (action.topic && action.topic === WS_TOPIC_INSTALLATION_LOGS) {
        switch (action.operation) {
          case wsEvents.EVENT_CREATE:
            return {
              ...state,
              list: {
                ...state.list,
                desynchronized: true,
              },
            };
          default:
            return state;
        }
      }
      return state;
    // LIST
    case GET_INSTALLATION_LOGS_LIST:
      // Note: Display loading and reset data only if the action is asked by user (i.e. desynchronized is false)
      return {
        ...state,
        list: {
          ...state.list,
          loading: !action.desynchronized,
          desynchronized: false,
          error: null,
          elements: {
            ...state.list.elements,
            data: action.desynchronized ? [...state.list.elements.data] : null,
          },
        },
      };
    case GET_INSTALLATION_LOGS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          desynchronized: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_LOGS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          desynchronized: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    default:
      return state;
  }
};

export default installationLog;



// WEBPACK FOOTER //
// ./reducers/installation/installationLog.js